// extracted by mini-css-extract-plugin
module.exports = {"aside":"aside_aside__3Xh4V","aside__nav":"aside_aside__nav__3djvm"};